import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const BASE_URL = import.meta.env.VITE_API_BASE_URL

export const api = createApi({
    reducerPath: 'api',
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL,
        credentials: 'include',
        prepareHeaders: (headers, { getState }) => {
            const token = (getState() as any).auth.accessToken
            if (token) {
                headers.set('Authorization', `Bearer ${token}`)
            }
            return headers
        },
    }),
    tagTypes: [
        'Categories',
        'Category',
        'ProductsByCatId',
        'Orders',
        'OrdersByPage',
        'Order',
        'Tables',
        'TableOrder',
        'Products',
        'ProductById',
        'Variations',
        'Variation',
        'Users',
        'ShopStatus',
    ],
    endpoints: () => ({}),
})
